<template>
  <div class="flex flex-wrap gap-2">
    <div
      v-for="{ name, id, color } in selectedCategories"
      :key="id"
      class="rounded-full p-0.5 px-3 flex whitespace-nowrap items-center gap-1 bg-[#F3F4F6] text-sm"
    >
      <div class="flex items-center gap-2">
        <span
          :class="`block size-2 rotate-45 translate-x-1`"
          :style="{ 'background-color': color }"
        />
        <span class="whitespace-nowrap">{{ name }}</span>
      </div>
      <button
        type="button"
        class="outline-none"
        @click="$emit('categoryRemoved', id)"
      >
        <TimesSmall custom-style="size-4" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoriesOvertimeBadges',

  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['categoryRemoved'],

  computed: {
    selectedCategories() {
      return this.categories
    },
  },
}
</script>
